var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.complainDetail.type == 'RAKUCHAT')?_c('RCchatHistory',{attrs:{"id":_vm.complainDetail.id}}):_vm._e(),(_vm.complainDetail.type == 'CHATWORK')?_c('CWchatHistory',{attrs:{"id":_vm.complainDetail.id}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }